import React, { useEffect } from 'react';
import { Box, DescriptionLabel, ErrorInfo, Grid, Progress, SectionHeader } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import Declaration from '../../../../components/Declaration';
import { denormalizedCandidate } from '../../logic/useCoordinatorResitData';
import SelectedSubjectsCandidatesReview from './SelectedSubjectsCandidatesReview';
import { ResitCandidateApplicationStatus } from '../../../../api/candidate/resit/@coordinator/model';
import { useGetGroupResitAndProfiles } from '../../../../api-refactored/group-resit-registration/useGetGroupResitAndProfiles';
import {
  CandidateModel,
  GroupResitSchema,
} from '../../../../api-refactored/group-resit-registration/model';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  header: {
    paddingTop: theme.spacing(6),
  },
}));

export interface GroupReviewProps {
  state: any;
  isAgreed: boolean;
  setIsAgreed: React.Dispatch<React.SetStateAction<boolean>>;
  declareError: boolean;
  setGroupFee: React.Dispatch<React.SetStateAction<GroupResitSchema | null>>;
  setNoOfCandidate: (num: number) => void;
  enabledPayment: boolean;
  resitUuid: string;
}

const GroupReview = ({
  state,
  isAgreed,
  setIsAgreed,
  declareError,
  setGroupFee,
  setNoOfCandidate,
  enabledPayment,
  resitUuid,
}: GroupReviewProps) => {
  const { classes } = useStyles();

  const denoData = denormalizedCandidate(state);

  const { data: groupResitAndProfiles } = useGetGroupResitAndProfiles({
    uuid: resitUuid,
    onSuccess: (resitAndProfiles) => {
      setGroupFee({
        resitCandidateList: (denoData as unknown) as CandidateModel[],
        totalPayment: resitAndProfiles.paymentModel,
      });
    },
  });

  useEffect(() => {
    setNoOfCandidate(denoData.length);
  }, [denoData.length, setNoOfCandidate]);

  if (!groupResitAndProfiles) {
    return <Progress color="secondary" />;
  }

  return (
    <>
      <Box className={classes.header}>
        {enabledPayment ? (
          <>
            <SectionHeader title="Review & Pay for Group" />
            <DescriptionLabel label="Please review all details before proceeding to payment" />
          </>
        ) : (
          <>
            <SectionHeader title="Group Confirmation Summary " />
            <DescriptionLabel label="Candidate(s) will pay individually for this registration, please review all details before sending email out to candidate(s)." />
          </>
        )}
      </Box>

      <SelectedSubjectsCandidatesReview
        hideStatus
        examFee
        noOfCandidate={groupResitAndProfiles.candidateSummary.length}
        candidateSubjects={groupResitAndProfiles.candidateSummary.map(
          (candidate) =>
          ({
            subjects: [
              {
                subject: candidate.subject,
                subjectCode: candidate.subjectCode,
                examSeries: candidate.examSeries,
                examFees: candidate.examFees,
                gst: candidate.gst,
                totalSubjectFees: candidate.totalSubjectFees,
              },
            ],
            statutoryName: candidate.candidateName,
            nricFin: candidate.uinfin,
          } as ResitCandidateApplicationStatus)
        )}
        totalExamFee={groupResitAndProfiles.paymentModel.totalExamFee || ''}
        totalGst={groupResitAndProfiles.paymentModel.totalGst || ''}
        totalFee={groupResitAndProfiles.paymentModel.totalFee || ''}
        totalPayable={groupResitAndProfiles.paymentModel.totalPayable || ''}
        gstAbsorbed={groupResitAndProfiles.paymentModel.gstAbsorbed || ''}
        enabledPayment={enabledPayment}
      />

      <br />

      <Grid xs={12}>
        <Declaration
          accountType="coordinator"
          title="Declaration"
          isAgreed={isAgreed}
          handleAgreement={() => setIsAgreed(!isAgreed)}
        />

        {declareError && <ErrorInfo label="Please confirm declaration before you proceed." />}
      </Grid>
    </>
  );
};

export default GroupReview;
